const PLACEHOLDER_PATTERN = /\{\{\s*([a-z0-9_]+)\s*\}\}/g;

const normalizeParameter = (value) => String(value).replace(/\s+/g, " ").trim();

export const parameterNames = (text) => {
  const found = [...new Set([...String(text || "").matchAll(PLACEHOLDER_PATTERN)].map((match) => match[1]))];
  if (found.length && found.every((name) => /^\d+$/.test(name))) {
    const highest = Math.max(...found.map(Number));
    return Array.from({ length: highest }, (_, index) => String(index + 1));
  }
  return found;
};

export const renderTemplateText = (text, parameters = [], names = null) => {
  const orderedNames = names ?? parameterNames(text);
  const values = Object.fromEntries(orderedNames.map((name, index) => [name, parameters[index]]));
  return (text || "").replace(PLACEHOLDER_PATTERN, (match, name) => {
    const value = values[name];
    const normalized = value != null ? normalizeParameter(value) : "";
    return normalized !== "" ? normalized : match;
  });
};

export const renderTemplatePreview = (template, parameters = [], headerParameters = []) => {
  if (!template) return "";
  const header = renderTemplateText(
    template.header_text,
    headerParameters,
    template.header_parameter_names ?? null,
  );
  const body = renderTemplateText(template.body_text, parameters, template.body_parameter_names ?? null);
  const buttons = (template.buttons || [])
    .map((button) => (button.text || "").trim())
    .filter(Boolean)
    .map((text) => `[${text}]`);
  const parts = [header, body, template.footer_text, ...buttons].filter(
    (part) => part && part.trim() !== "",
  );
  return parts.join("\n");
};

export const describeTags = (text, labels = {}) =>
  String(text || "").replace(PLACEHOLDER_PATTERN, (match, name) =>
    labels[name] ? `[${labels[name]}]` : match,
  );

export const emptyParameters = (count) =>
  Array.from({ length: Number(count) || 0 }, () => "");

export const valuesForNames = (names = [], tagValues = {}) =>
  names.map((name) => tagValues[name] ?? "");

export const missingParameters = (values = []) =>
  values.some((value) => !String(value ?? "").trim());
